import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import ProductCategory from './pages/ProductCategory';
import WeightTable from './pages/WeightTable';
import Industries from './pages/Industries';
import Contact from './pages/Contact';
import LoadingSpinner from './components/LoadingSpinner';
import { LanguageProvider } from './i18n/LanguageContext';

// Scroll to top and loading component
function ScrollToTopAndLoading() {
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Show loading
    setIsLoading(true);
    
    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    // Hide loading after a short delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 400);

    return () => clearTimeout(timer);
  }, [pathname]);

  return isLoading ? <LoadingSpinner /> : null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <ScrollToTopAndLoading />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:categorySlug" element={<ProductCategory />} />
              <Route path="/weight-table/:tableId" element={<WeightTable />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;